<script setup>
const isChecked = defineModel({ type: Boolean, default: false })

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
})

function toggleOption (option) {
  // Avoid manual override.
  if (props.isDisabled) {
    option.checked = !option.checked

    return
  }

  isChecked.value = option.checked
}
</script>

<template>
  <div class="base-toggle">
    <p v-if="props.label" class="base-toggle__label">
      {{ props.label }}
    </p>
    <label class="base-toggle__input">
      <input
        :disabled="props.isDisabled"
        :checked="isChecked"
        class="base-toggle__input-native"
        type="checkbox"
        style="display: none;"
        @input="toggleOption($event.target)"
      >
      <div class="base-toggle__input-custom" :class="{ 'base-toggle__input-custom--disabled': props.isDisabled }" />
    </label>
  </div>
</template>

<style lang="scss">
.base-toggle {
  $parent: &;

  display: flex;

  gap: $spacer-three-quarters;
  align-items: center;

  &__label {
    font-size: ms(-1);
  }

  &__input {
    position: relative;

    display: inline-block;

    width: 52px;
    height: 24px;

    &:hover:has(#{$parent}__input-native:not(:disabled)) {
      @media (hover: hover) {
        #{$parent}__input-custom {
          cursor: pointer;
        }
      }
    }
  }

  &__input-custom {
    position: absolute;

    transition: $transition-duration-slow;

    border-radius: 27px;

    background-color: $color-neutral-semidark;

    inset: 0;

    &::before {
      content: '';

      position: absolute;
      bottom: 1px;
      left: 1px;

      transition: $transition-duration-slow;

      border-radius: $border-radius-circular;
      width: 22px;
      height: 22px;

      background-color: $color-neutral-white;
    }

    &--disabled::before {
      background-color: $color-neutral-light;
    }
  }

  &__input-native:checked + &__input-custom {
    background-color: $color-secondary-medium;

    &--disabled {
      opacity: $opacity-level-intense;
    }
  }

  &__input-native:checked + &__input-custom::before {
    left: 0;

    transform: translateX(29px);
  }
}
</style>
